<div class="row">
	<div class="col">

		<h1 data-testid="SUBSYS2_DASHBOARD_TITLE_TXT" class="title-dashboard" [class.mt-0]="isCalendarVisible()">
			{{ labels().DASHBOARD_COMPONENT_TITLE }}
		</h1>

	</div>
</div>

<div class="row">
	<div class="col-12">
		<div class="wrapper-panel-dashboard">
			<div class="panel panel-card primary">
				<div class="wrapper-title-card">
					<h1 data-testid="SUBSYS2_DASHBOARD_CREATECARD_TITLE_TXT">
						{{ labels().DASHBOARD_COMPONENT_CARD_CREATE_TITLE }}
					</h1>
				</div>
				<div class="wrapper-btn-buttons-card">
					<button data-testid="SUBSYS2_DASHBOARD_CREATEPAT_BTN" type="button" class="btn" (click)="createPatient()">
						<i class="material-icons">person_add_alt</i>
						{{ labels().DASHBOARD_COMPONENT_CARD_CREATE_BTN_1 }}
					</button>
				</div>
			</div>

			<div class="panel panel-card primary">
				<div class="wrapper-title-card">
					<h1 data-testid="SUBSYS2_DASHBOARD_SEARCHCARD_TITLE_TXT">
						{{ labels().DASHBOARD_COMPONENT_CARD_SEARCH_TITLE }}
					</h1>
				</div>
				<div class="wrapper-btn-buttons-card">
					<button data-testid="SUBSYS2_DASHBOARD_SEARCHPLAN_BTN" type="button" class="btn" (click)="searchPatient()">
						<i class="material-icons">manage_search</i>
						{{ labels().DASHBOARD_COMPONENT_CARD_SEARCH_BTN }}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>

@if (isCalendarVisible()) {
<div class="row mt-5">
	<div class="col-12">
		<dashboard-filters />
	</div>
</div>

<div class="row mt-1">
	<div class="col-12">
		<div class="wrapper-panel-dashboard">

			<div class="panel panel-card">
				<dashboard-calendar />
			</div>

			<div class="panel panel-card">
				<dashboard-events />
			</div>

		</div>
	</div>
</div>
}

@if (signin(); as signin) {
<div class="info-signin">
	<label for="signin">{{ labels().DASHBOARD_COMPONENT_LAST_SIGNIN }}</label>
	<span>{{ signin!.date | convertDate }}, {{ signin!.date | date: "HH:mm:ss" }}</span><br />
	<span>{{ signin!.city }}, {{ signin!.state }}, {{ signin!.country }}</span>
</div>
}